import Api from './index';

const urlBase = '/segment/get_variable_value';

export function validateSegmentActivation(params) {
  return Api().post(urlBase, params);
}
